<template>
  <div class="m-bot">
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="pageSize"
      :total="pageCount"
      :pager-count="5"
      @current-change="changePageClick"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pageCount: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  methods: {
    changePageClick(page) {
      this.$emit('changePageClick', page)
    }
  }
}
</script>

<style scoped lang="scss">
.m-bot {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 38px;

  :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
    background-color: #1b56a9;
    color: #fff !important;
  }
  :deep(.el-pagination.is-background .el-pager li:not(.disabled):hover) {
    color: #1b56a9;
  }
  :deep(.el-pagination button, .el-pagination span:not([class*='suffix'])) {
    height: 40px;
    line-height: 40px;
    width: 40px;
  }
  :deep(.el-pagination .btn-next .el-icon) {
    font-size: 16px;
  }
  :deep(.el-pagination .btn-prev .el-icon) {
    font-size: 16px;
  }
  :deep(.el-pager li) {
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0 10px !important;
    font-size: 16px;
  }
}

// 手机端css
.mobile-content {
  .m-bot {
    margin-top: 20px;
    :deep(.el-pagination button, .el-pagination span:not([class*='suffix'])) {
      height: 28px;
      line-height: 28px;
      width: 28px;
    }
    :deep(.el-pagination .btn-next .el-icon) {
      font-size: 12px;
    }
    :deep(.el-pagination .btn-prev .el-icon) {
      font-size: 12px;
    }
    :deep(.el-pager li) {
      width: 28px;
      height: 28px;
      line-height: 28px;
      margin: 0 5px !important;
      font-size: 12px;
    }
  }
}
</style>
